/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Initialize_BtnInputs */

const en_onboarding_initialize_btn = /** @type {(inputs: Onboarding_Initialize_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialize Identity`)
};

const id_onboarding_initialize_btn = /** @type {(inputs: Onboarding_Initialize_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inisialisasi Identitas`)
};

/** @type {(inputs: Onboarding_Initialize_BtnInputs) => LocalizedString} */
const es_onboarding_initialize_btn = en_onboarding_initialize_btn;

/** @type {(inputs: Onboarding_Initialize_BtnInputs) => LocalizedString} */
const fr_onboarding_initialize_btn = en_onboarding_initialize_btn;

/** @type {(inputs: Onboarding_Initialize_BtnInputs) => LocalizedString} */
const de_onboarding_initialize_btn = en_onboarding_initialize_btn;

/** @type {(inputs: Onboarding_Initialize_BtnInputs) => LocalizedString} */
const ja_onboarding_initialize_btn = en_onboarding_initialize_btn;

/** @type {(inputs: Onboarding_Initialize_BtnInputs) => LocalizedString} */
const zh_onboarding_initialize_btn = en_onboarding_initialize_btn;

/** @type {(inputs: Onboarding_Initialize_BtnInputs) => LocalizedString} */
const ar_onboarding_initialize_btn = en_onboarding_initialize_btn;

/** @type {(inputs: Onboarding_Initialize_BtnInputs) => LocalizedString} */
const it_onboarding_initialize_btn = en_onboarding_initialize_btn;

/** @type {(inputs: Onboarding_Initialize_BtnInputs) => LocalizedString} */
const ru_onboarding_initialize_btn = en_onboarding_initialize_btn;

/** @type {(inputs: Onboarding_Initialize_BtnInputs) => LocalizedString} */
const pt_onboarding_initialize_btn = en_onboarding_initialize_btn;

/** @type {(inputs: Onboarding_Initialize_BtnInputs) => LocalizedString} */
const ko_onboarding_initialize_btn = en_onboarding_initialize_btn;

/**
* | output |
* | --- |
* | "Initialize Identity" |
*
* @param {Onboarding_Initialize_BtnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const onboarding_initialize_btn = /** @type {((inputs?: Onboarding_Initialize_BtnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Initialize_BtnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_initialize_btn(inputs)
	if (locale === "es") return es_onboarding_initialize_btn(inputs)
	if (locale === "fr") return fr_onboarding_initialize_btn(inputs)
	if (locale === "de") return de_onboarding_initialize_btn(inputs)
	if (locale === "ja") return ja_onboarding_initialize_btn(inputs)
	if (locale === "zh") return zh_onboarding_initialize_btn(inputs)
	if (locale === "ar") return ar_onboarding_initialize_btn(inputs)
	if (locale === "id") return id_onboarding_initialize_btn(inputs)
	if (locale === "it") return it_onboarding_initialize_btn(inputs)
	if (locale === "ru") return ru_onboarding_initialize_btn(inputs)
	if (locale === "pt") return pt_onboarding_initialize_btn(inputs)
	return ko_onboarding_initialize_btn(inputs)
});